import {Direction} from  '@/interfaces/insightsp2'

export interface IContentTable {
    title:string,
    tooltip?:string,
    data:any[],
    columns:IColumn[],
    csvDownload?:string
}

export interface IColumn {
    label:string,
    field:string,
    sortable:boolean,
    display:boolean,
    order:Direction|null,
    maxChars?:number|null,
    icon?:string|null,
    align?:string|null
}

export const initContentTable :IContentTable = {
    title:"",
    data:[],
    columns:[],
    csvDownload:""
}
